/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Office_Model_FranchisorInputs */

const cs_office_model_franchisor = /** @type {(inputs: Office_Model_FranchisorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchisor`)
};

const en_office_model_franchisor = /** @type {(inputs: Office_Model_FranchisorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchisor`)
};

/**
* | output |
* | --- |
* | "Franchisor" |
*
* @param {Office_Model_FranchisorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const office_model_franchisor = /** @type {((inputs?: Office_Model_FranchisorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Office_Model_FranchisorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_office_model_franchisor(inputs)
	return cs_office_model_franchisor(inputs)
});